import React, { Fragment, useState, useEffect } from 'react';
// react-switch is a UMD/CJS bundle that sets `exports.default` + `__esModule`
// at runtime but never `module.exports`, so Vite's dep optimizer leaves the
// default import as the `{ default, __esModule }` wrapper. Unwrap it here.
import ReactSwitch from "react-switch";
const Switch = ReactSwitch.default || ReactSwitch;

export default function FilterSwitch(props) {
  const [value, setValue] = useState(false);

  useEffect(() => {
    setValue(props.value || false)
  }, [props.value])

  function onChange(checked) {
    const filteredDisplay = checked
        ? props.displayName
        : '';
    props.onChangeCallback({
      filterName: props.filterName,
      value: checked ? true : null,
      filteredDisplay,
    });
    setValue(checked);
  }

  return (
  <Fragment>
    <div className='filter-definition-caption' style={{display: 'block'}}>{props.displayName}</div>
    <Switch
      onChange={(checked) => onChange(checked)}
      checked={value || false}
      height={props.height}
      width={props.width}
      handleDiameter={props.handleDiameter}
      onColor={props.onColor}
      offColor={props.offColor}
      uncheckedIcon={props.uncheckedIcon}
      checkedIcon={props.checkedIcon}
      activeBoxShadow={props.activeBoxShadow}
    />
  </Fragment>);
}
